import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { __ } from "@jti/fe-common";
import { Button, Dialog, Loading } from "@jti/ui";
import styles from "../DeliveryOptions.module.scss";
export const CustomDeliveryOptionModal = ({ webComponentRef, children, isLoading, error, selectedAddress, }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const closeModal = () => {
        setModalOpen(false);
    };
    const clean = () => {
        if (!webComponentRef.current) {
            return;
        }
        webComponentRef.current.addEventListener("customDeliveryOption:widget:modal:close", closeModal);
    };
    const toggleModal = useCallback(() => {
        setModalOpen((state) => !state);
    }, []);
    useEffect(() => {
        if (!webComponentRef.current) {
            return;
        }
        webComponentRef.current.addEventListener("customDeliveryOption:widget:modal:close", closeModal);
    }, [webComponentRef]);
    useEffect(() => clean(), []);
    return (_jsxs(_Fragment, { children: [selectedAddress ? (_jsx(Button, { onClick: toggleModal, color: "tertiary", "data-testid": "custom-delivery-change-store-cta", children: __("cart.checkout.delivery.custom.change_address") })) : (_jsx(Button, { className: styles.selectStoreCTA, isPending: isLoading, onClick: toggleModal, color: "primary", "data-testid": "custom-delivery-select-store-cta", children: __("cart.checkout.delivery.custom.cta") })), _jsxs(Dialog, { isOpened: isModalOpen, onClose: toggleModal, fullscreen: true, closable: true, children: [isLoading && _jsx(Loading, { dataTestId: "custom-delivery-modal-loading" }), error?.code === "SCRIPT_LOADING_ERROR" && _jsx("p", { children: __("cart.checkout.delivery.custom.error.script_loading") }), ["WIDGET_CRASH", "INVALID_STORE_ADDRESS"].includes(error?.code || "") && error?.message && (_jsx("p", { children: error.message })), children] })] }));
};
//# sourceMappingURL=CustomDeliveryOptionModal.js.map